import Icon from "../../utils/Icon";

const ModernPagination = ({page, total, size, onPageChange, ...props}) => {
    const start = (page - 1) * size + 1;
    const end = Math.min(page * size, total);
    const totalPages = Math.ceil(total / size);

    const handlePageChange = (e, newPage) => {
        e.preventDefault();
        e.stopPropagation();
        if (newPage >= 1 && newPage <= totalPages) {
            onPageChange(newPage);
        }
    };

    return (
        <div className="default_flex_container">
            <div>{start}-{end} of {total}</div>
            <div className="default_flex_container" style={{gap: 6, marginLeft: 12}}>
                <Icon name="CircleLeftArrow" style={{cursor: 'pointer'}} 
                    onClick={(e) => handlePageChange(e, page - 1)}/>
                <Icon name="CircleRightArrow" style={{cursor: 'pointer'}} 
                    onClick={(e) => handlePageChange(e, page + 1)}/>
            </div>
        </div>
    )
}

export default ModernPagination